<template>
  <div class="bg-warning/10 border-2 border-warning p-4 rounded-lg text-warning flex items-center justify-between">
    <span> {{ label }} is missing. Please fill it in. </span>
    <button @click="$emit('fill')" class="btn btn-sm btn-outline btn-warning">Fill now</button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ label: string }>();
const emit = defineEmits<{ (e: "fill"): void }>();
</script>
